export const html = {
    set(html, { elem }) {
        elem.innerHTML = `${html}`;
    },
};
//# sourceMappingURL=html.js.map